import React, {Component} from 'react';
import _ from "lodash";

export default ComposedComponent => {
    class ResizeWindow extends Component {

        constructor(props) {
            super(props);
            this.state = {
                isHidden1200: document.body.clientWidth <= 1200,
                isHidden990: document.body.clientWidth <= 990,
                isHidden768: document.body.clientWidth <= 768,
                isHidden640: document.body.clientWidth <= 640,
            };
            this.updatePredicate = this.updatePredicate.bind(this);

            this.updateResize = _.debounce(this.updatePredicate, 500);
        }

        componentDidMount() {
            this.updateResize();
            window.addEventListener("resize", this.updateResize);
        }

        componentWillUnmount() {
            this.updateResize.cancel();
            window.removeEventListener("resize", this.updateResize);
        }

        updatePredicate() {
            let {isHidden1200 = false, isHidden990 = false, isHidden768 = false, isHidden640 = false} = this.state;

            if (window.innerWidth <= 1200 && !this.state.isHidden990) {
                isHidden1200 = true;
            }
            if (window.innerWidth > 1200) {
                isHidden1200 = false;
            }
            if (window.innerWidth <= 990 && !this.state.isHidden990) {
                isHidden990 = true;
            }
            if (window.innerWidth > 990 && this.state.isHidden990) {
                isHidden990 = false;
            }
            if (window.innerWidth <= 768 && !this.state.isHidden768) {
                isHidden768 = true;
            }
            if (window.innerWidth > 768 && this.state.isHidden768) {
                isHidden768 = false;
            }
            if (window.innerWidth <= 640 && !this.state.isHidden640) {
                isHidden640 = true;
            }
            if (window.innerWidth > 640 && this.state.isHidden640) {
                isHidden640 = false;
            }
            this.setState({isHidden1200, isHidden990, isHidden768, isHidden640});
        }

        render() {
            return <ComposedComponent
                {...this.props}
                {...this.state}
            />
        }
    }

    return ResizeWindow;
}
